import React, { useEffect, useState } from "react";
import { Modal, Form, Row, Col, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  insertTranspoterDatabyContainerNoForVizio,
  updateFormContainerData,
  updateFormContainerDataAggregate,
  updateFormContainerData5M,
} from "../../services/ContainerMasterService";
import { dispatcher } from "../../store/storeHelpers";
import { ADD_CONTAINER_DATA } from "../../store/ActionTypes";
import { findIndex } from "lodash";
import { getPickupLocation } from "../../services/VGMService";
import Select from "react-select";
import moment from "moment";
import { invPackingDocValidation } from "../../services/dataService";

function ContainerAdd({ show, hide, tableData, showFactoryOutModal, setShowFactoryOutModal }) {
  const [containerValue, setCotainerValue] = useState({
    invoice: show.row.original.invoice,
    T_qty: show.row.original.T_qty,
    A_qty: show.row.original.A_qty,
    A_Part: show.row.original.A_Part,
    RFID_Seal_No: show.row.original.RFID_Seal_No,
    Product: show.row.original.Product,
    pick_up_location: show.row.original.pick_up_location,
    SAP_code: show.row.original.Container_Type === "40HC" ? "ST40" : "STD-2M",
    Remarks: show.row.original.Remarks,
  });
  const [dateValue, setDateValue] = useState(
    moment(show.row.original.Gate_Out_Date).format("YYYY-MM-DD")
  );
  const [timeValue, setTimeValue] = useState(
    moment(show.row.original.Gate_Out_Date).format("HH:mm")
  );

  const [pickupLocation, setPickupLocation] = useState([]);
  const [error, setError] = useState("");
  const [invError, setInvError] = useState("")
  const [disableUpdateByTractorQty, setDisableUpdateByTractorQty] = useState(false)

  const [btnState, setBtnState] = useState({
    text: "Update",
    disable: false,
  });

  const requestPickupLocation = async () => {
    const response = await getPickupLocation();
    setPickupLocation(response.data);
  };

  useEffect(() => {
    const findId = findIndex(tableData, {
      DailyContainerPlanningId: show.row.original.DailyContainerPlanningId,
    });
    if (tableData[findId]["DataOf"] === "TRACTOR") {
      if (
        tableData[findId]["invoice"] ||
        tableData[findId]["T_qty"] ||
        tableData[findId]["A_qty"] ||
        tableData[findId]["A_Part"] ||
        tableData[findId]["RFID_Seal_No"] ||
        tableData[findId]["Product"] ||
        tableData[findId]["pick_up_location"] ||
        tableData[findId]["SAP_code"] ||
        tableData[findId]["Remarks"]
      ) {
        if (
          tableData[findId]["DailyContainerPlanningId"] ===
          show.row.original.DailyContainerPlanningId
        ) {
          setBtnState({
            text: "Update",
            disable: true,
          });
        }
      } else {
        setBtnState({
          text: "Update",
          disable: false,
        });
      }
    }
    if (tableData[findId]["DataOf"] === "AGGREGATE") {
      if (
        tableData[findId]["invoice"] ||
        tableData[findId]["T_qty"] ||
        tableData[findId]["A_qty"] ||
        tableData[findId]["A_Part"] ||
        tableData[findId]["RFID_Seal_No"] ||
        tableData[findId]["Product"] ||
        tableData[findId]["pick_up_location"] ||
        tableData[findId]["SAP_code"] ||
        tableData[findId]["Remarks"]
      ) {
        if (
          tableData[findId]["DailyContainerPlanningId"] ===
          show.row.original.DailyContainerPlanningId
        ) {
          setBtnState({
            text: "Update",
            disable: true,
          });
        }
      } else {
        setBtnState({
          text: "Update",
          disable: false,
        });
      }
    }
    if (tableData[findId]["DataOf"] === "5M") {
      if (
        tableData[findId]["invoice"] ||
        tableData[findId]["T_qty"] ||
        tableData[findId]["A_qty"] ||
        tableData[findId]["A_Part"] ||
        tableData[findId]["RFID_Seal_No"] ||
        tableData[findId]["Product"] ||
        tableData[findId]["pick_up_location"] ||
        tableData[findId]["SAP_code"] ||
        tableData[findId]["Remarks"]
      ) {
        if (
          tableData[findId]["DailyContainerPlanningId"] ===
          show.row.original.DailyContainerPlanningId
        ) {
          setBtnState({
            text: "Update",
            disable: true,
          });
        }
      } else {
        setBtnState({
          text: "Update",
          disable: false,
        });
      }
    }
  }, [tableData, show]);

  function handleTextChange(e) {
    setCotainerValue({ ...containerValue, [e.target.name]: e.target.value });
    if(e.target.name === "invoice"){
      if(e.target.value.length > 0) setInvError("")
      else setInvError("Invoice number not entered.")
    }
  }

  const handleTractorQtyChange = (e) => {
    const val = parseInt(e.target.value);
    if (val <= 8 && val >= 1) {
      setError("");
      setDisableUpdateByTractorQty(false)
      setCotainerValue({ ...containerValue, [e.target.name]: e.target.value });
    } else {
      setCotainerValue({ ...containerValue, T_qty: null });
      if (val) {
        setDisableUpdateByTractorQty(true)
        setError("Tractor quantity value must be between 1 to 8 ");
      } else {
        setError("");
      }
    }
  };

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      const validationResponse = await invPackingDocValidation(show.row.original.ContainerMasterId, show.row.original.DataOf)
      if ((dateValue !== "Invalid date" )&& (validationResponse.data[0]["Successcode"] === 400)) {
        toast.error((validationResponse.data[0]["Message"]).split(".")[0]);
      }else{
        let addDataToVizio = {
          ContainerNumber: show.row.original.Container_Number,
          ContainerSize: show.row.original.Container_Type,
          BookingID: show.row.original.Booking_Number,
          PickupLocation: containerValue.pick_up_location,
          Clearance: show.row.original.Clearence,
          Carries: show.row.original.Carrier,
          Transporter: show.row.original.Transporter,
          VGM: false,
          Type: show.row.original.DataOf,
        };
        var tractorMount = false;
        var aggMount = false;
        var fiveMMount = false;
        if (show.row.original.ContainerMasterId) {
          try {
            if (show.row.original.DataOf === "TRACTOR") {
              let tractorPayload = {
                ContainerMasterID: show.row.original.ContainerMasterId,
                Invoice: containerValue.invoice,
                TQty: containerValue.T_qty,
                A_qty: containerValue.A_qty,
                A_Part: containerValue.A_Part,
                RFID_Seal_No: containerValue.RFID_Seal_No,
                Product: containerValue.Product,
                Pick_up_location: containerValue.pick_up_location,
                Sap_code: containerValue.SAP_code,
                Remarks: containerValue.Remarks,
                Gate_Out_Date: (dateValue === "Invalid date" || timeValue === "Invalid date") ? "" : `${dateValue}T${timeValue}`,
              };
              setBtnState({
                text: "Updating",
                disable: true,
              });
              await updateFormContainerData(tractorPayload);
              await insertTranspoterDatabyContainerNoForVizio(addDataToVizio);
              dispatcher(ADD_CONTAINER_DATA, {
                containerValue: containerValue,
                dateValue,
                timeValue,
                ContainerMasterId: show.row.original.ContainerMasterId,
              });
              setBtnState({
                text: "Update",
                disable: true,
              });
              hide();
              tractorMount = true;
            }
            if (show.row.original.DataOf === "AGGREGATE") {
              let aggregatePayload = {
                ContainerMasterID: show.row.original.ContainerMasterId,
                Invoice: containerValue.invoice,
                TQty: containerValue.T_qty,
                A_qty: containerValue.A_qty,
                A_Part: containerValue.A_Part,
                RFID_Seal_No: containerValue.RFID_Seal_No,
                Product: containerValue.Product,
                Pick_up_location: containerValue.pick_up_location,
                Sap_code: containerValue.SAP_code,
                Remarks: containerValue.Remarks,
                Gate_Out_Date: (dateValue === "Invalid date" || timeValue === "Invalid date") ? "" : `${dateValue}T${timeValue}`,
              };
              setBtnState({
                text: "Updating",
                disable: true,
              });
              await updateFormContainerDataAggregate(aggregatePayload);
              await insertTranspoterDatabyContainerNoForVizio(addDataToVizio);
              dispatcher(ADD_CONTAINER_DATA, {
                containerValue: containerValue,
                dateValue,
                timeValue,
                ContainerMasterId: show.row.original.ContainerMasterId,
              });
              setBtnState({
                text: "Update",
                disable: true,
              });
              hide();
              aggMount = true;
            }
            if (show.row.original.DataOf === "5M") {
              let fiveMPayload = {
                ContainerMasterID: show.row.original.ContainerMasterId,
                Invoice: containerValue.invoice,
                TQty: containerValue.T_qty,
                A_qty: containerValue.A_qty,
                A_Part: containerValue.A_Part,
                RFID_Seal_No: containerValue.RFID_Seal_No,
                Product: containerValue.Product,
                Pick_up_location: containerValue.pick_up_location,
                Sap_code: containerValue.SAP_code,
                Remarks: containerValue.Remarks,
                Gate_Out_Date: (dateValue === "Invalid date" || timeValue === "Invalid date") ? "" : `${dateValue}T${timeValue}`,
              };
              setBtnState({
                text: "Updating",
                disable: true,
              });
              await updateFormContainerData5M(fiveMPayload);
              await insertTranspoterDatabyContainerNoForVizio(addDataToVizio);
              dispatcher(ADD_CONTAINER_DATA, {
                containerValue: containerValue,
                dateValue,
                timeValue,
                ContainerMasterId: show.row.original.ContainerMasterId,
              });
              setBtnState({
                text: "Update",
                disable: true,
              });
              hide();
              fiveMMount = true;
            }
            if (tractorMount || aggMount || fiveMMount) {
              toast.success("Container Master Data updated successfully");
            }
          } catch (error) {
            setBtnState({
              text: "Update",
              disable: false,
            });
            toast.error("Unable to update container master data");
          }
        }
      }
    } catch (error) {
      toast.error("Something went wrong...please try again")
    }
  }

  function clearForm() {
    setCotainerValue({
      invoice: "",
      T_qty: "",
      A_qty: "",
      A_Part: "",
      RFID_Seal_No: "",
      Product: "",
      pick_up_location: "",
      Remarks: "",
    });
  }

  useEffect(() => {
    if (
      containerValue.invoice ||
      containerValue.T_qty ||
      containerValue.A_qty ||
      containerValue.A_Part ||
      containerValue.RFID_Seal_No ||
      containerValue.Product ||
      containerValue.pick_up_location ||
      containerValue.SAP_code ||
      containerValue.Remarks
    ) {
      setBtnState({
        text: "Update",
        disable: false,
      });
    } else {
      setBtnState({
        text: "Update",
        disable: true,
      });
    }
    requestPickupLocation();
  }, [containerValue]);

  return (
    <>
      <Modal show={show || showFactoryOutModal} centered dialogClassName="addcontainer__group">
        <Modal.Body>
          <div>
            <div className="addcontainer__header">
              <h3>Container Details</h3>
              <button className="addcontainer__closeBtn" onClick={hide}>
                <i class="bx bxs-x-square"></i>
              </button>
            </div>
            <p
              style={{ fontWeight: "400", marginTop: "15px", fontSize: "22px" }}
            >{`#${show.row.original.Container_Number}`}</p>
            <div className="container-form">
              <div className="container-data">
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Form.Group as={Col} className="mb-3">
                      <Form.Label style={{ fontWeight: "500" }}>
                        Invoice
                      </Form.Label>
                      <Form.Control
                        value={containerValue.invoice}
                        name="invoice"
                        onChange={handleTextChange}
                        placeholder="Enter Invoice"
                      />
                    </Form.Group>

                    <Form.Group as={Col} className="mb-3">
                      <Form.Label style={{ fontWeight: "500" }}>
                        Tractor Qty
                      </Form.Label>
                      <Form.Control
                        value={containerValue.T_qty}
                        name="T_qty"
                        onChange={handleTractorQtyChange}
                        placeholder="Enter Tractor Qty"
                        maxLength={1}
                      />
                      {error && <p style={{ color: "red", fontSize:"13px", fontWeight:"500" }}>{error}</p>}
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} className="mb-3">
                      <Form.Label style={{ fontWeight: "500" }}>
                        Aggregate Qty
                      </Form.Label>
                      <Form.Control
                        value={containerValue.A_qty}
                        name="A_qty"
                        onChange={handleTextChange}
                        placeholder="Enter A Qty"
                      />
                    </Form.Group>
                    <Form.Group as={Col} className="mb-3">
                      <Form.Label style={{ fontWeight: "500" }}>
                        Aggregate Part
                      </Form.Label>
                      <Form.Control
                        value={containerValue.A_Part}
                        name="A_Part"
                        onChange={handleTextChange}
                        placeholder="Enter A Part"
                      />
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} className="mb-3">
                      <Form.Label style={{ fontWeight: "500" }}>
                        RFID Seal No
                      </Form.Label>
                      <Form.Control
                        name="RFID_Seal_No"
                        onChange={handleTextChange}
                        value={containerValue.RFID_Seal_No}
                        placeholder="Enter RFID Seal No"
                      />
                    </Form.Group>
                    <Form.Group as={Col} className="mb-3">
                      <Form.Label style={{ fontWeight: "500" }}>
                        Product
                      </Form.Label>
                      <Form.Control
                        name="Product"
                        value={containerValue.Product}
                        onChange={handleTextChange}
                        placeholder="Enter Product"
                      />
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} className="mb-3">
                      <Form.Label style={{ fontWeight: "500" }}>
                        Pick Up Location
                      </Form.Label>
                      <Select
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        getOptionLabel={(location) => location.Pickup_Location}
                        getOptionValue={(location) => location.Pickup_Location}
                        options={pickupLocation}
                        placeholder="Select Location..."
                        className="pickup_location_dropdown"
                        maxMenuHeight={200}
                        name="pick_up_location"
                        value={{
                          Pickup_Location: containerValue.pick_up_location,
                        }}
                        onChange={(option) =>
                          setCotainerValue({
                            ...containerValue,
                            pick_up_location: option["Pickup_Location"],
                          })
                        }
                      />
                    </Form.Group>
                    <Form.Group as={Col} className="mb-3">
                      <Form.Label style={{ fontWeight: "500" }}>
                        SAP Code
                      </Form.Label>
                      <Form.Control
                        value={containerValue.SAP_code}
                        name="SAP_code"
                        placeholder="Enter SAP Code"
                        disabled
                      />
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} className="mb-3">
                      <Form.Label style={{ fontWeight: "500" }}>
                        Remarks
                      </Form.Label>
                      <Form.Control
                        value={containerValue.Remarks}
                        name="Remarks"
                        onChange={handleTextChange}
                        placeholder="Enter Remarks"
                      />
                    </Form.Group>
                    <>
                      <Form.Group as={Col} className="mb-3">
                        <Form.Label style={{ fontWeight: "500" }}>
                          {"Factory Out Date & Time"}
                        </Form.Label>
                        <div style={{ display: "flex" }}>
                          <Form.Control
                            type="date"
                            className="table_input"
                            value={`${dateValue}`}
                            onChange={(e) =>{
                              setDateValue(e.currentTarget.value)
                              if(!containerValue.invoice){
                                setInvError("Invoice number not entered.")
                              }else{
                                setInvError("")
                              }
                            }}
                            style={{ width: "50%", height: "40px" }}
                          />
                          <Form.Control
                            type="time"
                            className="table_input"
                            value={`${timeValue}`}
                            onChange={(e) =>{
                              setTimeValue(e.currentTarget.value)
                              if(!containerValue.invoice){
                                setInvError("Invoice number not entered.")
                              }else{
                                setInvError("")
                              }
                            }}
                            style={{ width: "50%", height: "40px" }}
                          />
                        </div>
                      {invError && <div style={{ color: "red", fontSize:"13px", marginTop:"5px", fontWeight:"500" }}>{invError}</div>}
                      </Form.Group>
                    </>
                  </Row>
                  <div className="addContainer__BtnClass">
                    <Button
                      variant="primary"
                      className="form-btn"
                      type="submit"
                      disabled={btnState.disable || disableUpdateByTractorQty}
                    >
                      {btnState.text}
                    </Button>
                    <Button
                      variant="primary"
                      className="form-btn form-clear-btn"
                      onClick={clearForm}
                    >
                      Clear form
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default ContainerAdd;
